<template>
    <div>
        <p class="label" :class="{'text--disabled': disabled}">{{ label }}</p>
        <MultiplePickerInput
                :value="value"
                @input="onInput"
                :items="items"
                :loading="loading"
                :disabled-check-all="true"
                v-bind="$attrs"
                :disabled="disabled"
        />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';

  export default {
    name: "ObtainedSpecialityMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array,
      label: { type: String, default: 'Spécialité(s) étudié(s)'},
      obtainedMajorIds: {type: Array, default: () => []},
      listOriginal: Array,
    },
    data() {
      return {
        loading: false,
        timeoutHandler: null,
      }
    },
    computed: {
      items() {
        const _this = this;

        const items = [];

        const itemNoBelongGroup = _this.listOriginal.find(item => {
          return !item.id;
        });

        if (itemNoBelongGroup) {
          itemNoBelongGroup.children.forEach((item) => {
            items.push(
              Object.assign({}, item)
            );
          });
        }

        _this.obtainedMajorIds.forEach((id, index) => {
          const group = _this.listOriginal.find(item => {
            return item.id === id;
          });

          if (!group) return;

          if (index) items.push({ divider: true });

          items.push({header: group.name});

          group.children.forEach((item) => {
            items.push(
              Object.assign({}, item)
            );
          });
        });

        return items;
      },
      disabled() {
        return this.items && !this.items.length;
      }
    },
    methods: {
      onInput(event) {
        this.$emit('input', event);
      }
    },
    watch: {
      obtainedMajorIds: {
        immediate: true,
        handler(value) {
          this.$emit('input', []);
        }
      },
    }
  }
</script>

<style scoped>

</style>
